module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point3_4-f6804ca2e0068387c26196619b3fb5a3.jpg";